// Deterministischer Renderer für Abschnitt „1.5 Zeitangaben".
// Wird sowohl im Editor (Anzeige/Generierung) als auch beim Zusammenbau des
// fertigen Berichts (collectReportData → Export) verwendet, damit beide IDENTISCH
// sind und der Abschnitt NIE einfriert: Er wird immer live aus den aktuellen
// Beratungstagen berechnet.
//
// Regel: Beratungszeitraum = erster–letzter erfasster Beratungstag.
// Ohne Beratungstage bleibt der Zeitraum LEER — KEIN Fallback auf manuelle
// Start-/Enddaten (das ist der Bewilligungszeitraum, nicht der Beratungszeitraum).

export interface ConsultingDayInput { date: string; hours: string }
export interface ConsultantInput { name: string }

function fmtDate(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

export function buildZeitangabenHtml(
  consultingDays: ConsultingDayInput[],
  consultants: ConsultantInput[],
): string {
  const beraterNamen = (consultants || []).filter(c => c?.name?.trim()).map(c => c.name);
  const tage = (consultingDays || []).filter(d => d?.date);
  const gesamtStunden = tage.reduce((sum, d) => sum + (parseFloat(d.hours) || 0), 0);

  // Für den Zeitraum NUR gültige ISO-Daten (YYYY-MM-DD) heranziehen — ein vertipptes
  // Datum (z.B. "28.01.202") darf die Sortierung und damit den angezeigten Zeitraum
  // nicht verfälschen. KEIN Fallback: ohne gültige Beratungstage bleibt der Zeitraum leer.
  const isoDates = tage.map(d => d.date).filter(s => /^\d{4}-\d{2}-\d{2}$/.test(s)).sort();
  const startDate = isoDates.length > 0 ? isoDates[0] : '';
  const endDate = isoDates.length > 0 ? isoDates[isoDates.length - 1] : '';

  let html = `<h2>1.5 Zeitangaben</h2>\n`;

  if (beraterNamen.length > 0) {
    html += `<p style="font-size:14px;"><strong>Berater:</strong> ${beraterNamen.join(', ')}</p>\n`;
  }
  if (startDate || endDate) {
    html += `<p style="font-size:14px;"><strong>Beratungszeitraum:</strong> ${startDate ? fmtDate(startDate) : '–'} bis ${endDate ? fmtDate(endDate) : '–'}</p>\n`;
  }
  if (tage.length > 0) {
    html += `<p style="font-size:14px;"><strong>Anzahl Beratungstage:</strong> ${Math.ceil(gesamtStunden / 8)}</p>\n`;
    html += `<p style="font-size:14px;"><strong>Gesamtstunden:</strong> ${gesamtStunden}</p>\n`;
    html += `<table style="font-size:14px; border-collapse:collapse; width:100%; margin-top:8px;">`;
    html += `<tr style="border-bottom:1px solid #e2e8f0;"><th style="text-align:left; padding:6px 8px;">Datum</th><th style="text-align:left; padding:6px 8px;">Stunden</th></tr>`;
    tage.forEach(d => {
      html += `<tr style="border-bottom:1px solid #f1f5f9;"><td style="padding:6px 8px;">${fmtDate(d.date)}</td><td style="padding:6px 8px;">${d.hours} h</td></tr>`;
    });
    html += `</table>\n`;
  }
  return html;
}
